import { AIModel, UserModelSettings, UserModelSettingsBulkResponse } from '../../types/modelTypes'
import { axiosClient } from '../axiosClient'

export const modelsFunctions = {
  async fetchModels(category?: string): Promise<AIModel[]> {
    const params = category ? { category } : {}
    return axiosClient.get('/api/models/', { params })
  },

  async fetchUserModelSettings(): Promise<UserModelSettingsBulkResponse> {
    return axiosClient.get('/api/models/settings')
  },

  async updateUserModelSettings(
    aiModelId: string,
    settings: Record<string, number | string>,
  ): Promise<UserModelSettings> {
    return axiosClient.put(`/api/models/settings/${aiModelId}`, { settings })
  },
}
